<template>
  <div class="contentPrintReport">
    <iframe
      width="0"
      height="0"
      style="background-color: white"
      frameborder="0"
      id="printf"
      name="printf"
      loading="lazy"
      allowfullscreen
      referrerpolicy="no-referrer-when-downgrade"
    ></iframe>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";

export default {
  data() {
    return {};
  },
  methods: {
    ...mapMutations(["SET_HTML_TO_PRINT"]),
    printReport() {
      if (this.htmlToPrint) {
        const iframe = document.getElementById("printf");
        const iframeDoc =
          iframe?.contentDocument || iframe?.contentWindow?.document;

        iframeDoc.body.innerHTML = this.htmlToPrint;

        const iframeWindow = iframe.contentWindow;
        iframeWindow.focus();
        iframeWindow.print();

        this.SET_HTML_TO_PRINT("");
      }
    },
  },
  computed: {
    ...mapState(["htmlToPrint"]),
  },
  watch: {
    htmlToPrint() {
      this.printReport();
    },
  },
};
</script>

<style scoped>
.contentPrintReport {
  display: none;
}
</style>